import '.a0{position:fixed;}.ssr-plugin'
import '.cx{top:0;}.ssr-plugin'
import '.bj{left:0px;}.ssr-plugin'
import '.bk{right:0px;}.ssr-plugin'
import '.fl{bottom:0px;}.ssr-plugin'
import '.gz{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.h0{z-index:998;}.ssr-plugin'
import '.h1{transition:opacity 0.3s ease;}.ssr-plugin'
import '.s{height:100vh;}.ssr-plugin'
import '.a2{width:100%;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.h2{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.h3{z-index:999;}.ssr-plugin'
import '.i{display:flex;}.ssr-plugin'
import '.j{flex-direction:column;}.ssr-plugin'
import '.k{align-items:center;}.ssr-plugin'
import '.a3{justify-content:space-between;}.ssr-plugin'
import '.bs{padding:1.5rem;}.ssr-plugin'
import '.h4{border-bottom:1px solid var(--gray-border);}.ssr-plugin'
import '.c3{flex-shrink:0;}.ssr-plugin'
import '.c5{flex:1;}.ssr-plugin'
import '.ar{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="a0 cx bj bk fl gz h0 h1"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="a0 cx s a2 ae h2 h3 i j"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="i k a3 bs h4 c3"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="c5 ar bs"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
